//import { getToken, setToken } from 'config';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
    registerUser,
    registerUserIdle,
    registerUserSuccess,
    //registerUserSetToken,
} from 'store/ducks/registration/actions';
import { StateStatus } from 'types/models';
const activities = [
    'нет',
    'Производство контента',
    'Услуги платного ТВ',
    'Поставка вещательного оборудования',
    'Дистрибуция контента',
    'Доставка телесигнала',
    'Телезритель',
    'Другое',
];

export default function RegForm() {
    const {
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors },
    } = useForm();

    // console.log(errors);

    type ServerErrors = {
        username: any[];
        email: any[];
        password: any[];
        password_confirmation: any[];
        name: any[];
        surname: any[];
        organization: any[];
        field_of_activity: any[];
    };

    const dispatch = useDispatch();

    const status = useSelector(
        (state: { userRegister: { status: StateStatus } }) =>
            state.userRegister.status
    );
    /*const token = useSelector(
        (state: { userRegister: { token: string } }) => state.userRegister.token
    );*/
    const messages = useSelector(
        (state: { userRegister: { messages: any } }) =>
            state.userRegister.messages
    );
    const [serverErrors, setServerErrors]: any = useState({});

    useEffect(() => {
        if (status == 'SUCCESS') {

            if (messages.id){
                reset();
                setServerErrors({});
            }
             
        }
    }, [status]);

    useEffect(() => {
        if (
            messages &&
            messages.errors &&
            Object.keys(messages.errors).length > 0
        ) {
            Object.keys(messages.errors).map(item => {
                let newErrors = {
                    ...errors,
                    [item]: messages.errors[item],
                };
                setServerErrors(newErrors);
            });
        }
    }, [messages]);

    useEffect(() => {
        // console.log('serverErrors: ', serverErrors);
    }, [serverErrors]);

    /*useEffect(() => {
        if (status === 'SUCCESS') {
            //setToken(token);
            dispatch(registerUserIdle());
        }
    }, [status]);*/

    const onSubmit = (data: any) => {
        dispatch(registerUser(data));
    };

    const [truePass, setTruePass] = useState(true);
    useEffect(() => {
        watch(value => {
            if (value.password && value.password_confirmation) {
                if (value.password === value.password_confirmation) {
                    setTruePass(true);
                } else {
                    setTruePass(false);
                }
            }
        });
    }, [watch]);

    return (
        <>
            <form
                className="profile-form profile-form--registration page-profile__form page-profile__form--registration"
                onSubmit={handleSubmit(onSubmit)}
            >
                <div className="profile-form__row">
                    <div className="profile-form__column">
                        <label className="profile-form__label">
                            Логин
                            <span>*</span>
                        </label>
                        <input
                            placeholder="Введите логин"
                            {...register('username', {
                                required: {
                                    value: true,
                                    message: 'Это поле обязательное',
                                },
                                minLength: {
                                    value: 3,
                                    message: 'Минимум 3 символа',
                                },
                            })}
                            className="profile-form__input"
                        />
                        {/* <span >
                            минимум 3 символа
                        </span> */}
                        {errors.username && (
                            <span className="profile-form__input-description">
                                {errors.username.message}
                            </span>
                        )}
                        {serverErrors &&
                            serverErrors.username &&
                            serverErrors.username.length > 0 &&
                            serverErrors.username.map((item: string, index: number) => {
                                return (
                                    <span key={index} className="profile-form__input-description">
                                        {item}
                                    </span>
                                );
                            })}
                    </div>
                    <div className="profile-form__column">
                        <label className="profile-form__label">
                            Адрес e-mail
                            <span>*</span>
                        </label>
                        <input
                            type="email"
                            className="profile-form__input"
                            placeholder="Адрес e-mail"
                            {...register('email', {
                                required: {
                                    value: true,
                                    message: 'Это поле обязательное',
                                },
                                pattern: {
                                    value: /\S+@\S+\.\S+/,
                                    message: 'Формат почты не правильный',
                                },
                            })}
                        />
                        {errors.email && (
                            <span className="profile-form__input-description">
                                {errors.email.message}
                            </span>
                        )}
                        {serverErrors &&
                            serverErrors.email &&
                            serverErrors.email.length > 0 &&
                            serverErrors.email.map((item: string, index: number) => {
                                return (
                                    <span key={index} className="profile-form__input-description">
                                        {item}
                                    </span>
                                );
                            })}
                    </div>
                </div>
                <div className="profile-form__row">
                    <div className="profile-form__column">
                        <label className="profile-form__label">
                            Пароль
                            <span>*</span>
                        </label>
                        <input
                            id="profileFormPassword"
                            type="password"
                            className="profile-form__input"
                            {...register('password', {
                                required: {
                                    value: true,
                                    message: 'Это поле обязательное',
                                },
                                minLength: {
                                    value: 6,
                                    message: 'Минимум 6 символов',
                                },
                                pattern: {
                                    value: /[A-Za-z0-9]+/g,
                                    message:
                                        'Пароль должен состоять из букв латинского алфавита (A-z), арабских цифр (0-9)',
                                },
                            })}
                            placeholder="Введите пароль"
                        />
                        {/* <span className="profile-form__input-description">
                            не менее 6 символов и содержать цифры (0-9)
                        </span> */}
                        {errors.password && (
                            <span className="profile-form__input-description">
                                {errors.password.message}
                            </span>
                        )}
                        {serverErrors &&
                            serverErrors.password &&
                            serverErrors.password.length > 0 &&
                            serverErrors.password.map((item: string, index: number) => {
                                return (
                                    <span key={index} className="profile-form__input-description">
                                        {item}
                                    </span>
                                );
                            })}
                    </div>
                    <div className="profile-form__column">
                        <label className="profile-form__label">
                            Введите пароль повторно
                            <span>*</span>
                        </label>
                        <input
                            id="profileFormConfirmPassword"
                            type="password"
                            className="profile-form__input"
                            {...register('password_confirmation', {
                                required: {
                                    value: true,
                                    message: 'Это поле обязательное',
                                },
                            })}
                            placeholder="Введите пароль повторно"
                        />
                        {errors.password_confirmation && (
                            <span className="profile-form__input-description">
                                {errors.password_confirmation.message}
                            </span>
                        )}
                        {!truePass && <span>Пароли не совпадают.</span>}
                        {serverErrors &&
                            serverErrors.password_confirmation &&
                            serverErrors.password_confirmation.length > 0 &&
                            serverErrors.password_confirmation.map(
                                (item: string, index: number) => {
                                    return (
                                        <span key={index} className="profile-form__input-description">
                                            {item}
                                        </span>
                                    );
                                }
                            )}
                    </div>
                </div>
                <div className="profile-form__row">
                    <div className="profile-form__column">
                        <label className="profile-form__label">
                            Имя
                            <span>*</span>
                        </label>
                        <input
                            id="profileFormName"
                            className="profile-form__input"
                            {...register('name', {
                                required: {
                                    value: true,
                                    message: 'Это поле обязательное',
                                },
                            })}
                            placeholder="Введите имя"
                        />
                        {errors.name && (
                            <span className="profile-form__input-description">
                                {errors.name.message}
                            </span>
                        )}
                        {serverErrors &&
                            serverErrors.name &&
                            serverErrors.name.length > 0 &&
                            serverErrors.name.map((item: string, index: number) => {
                                return (
                                    <span key={index} className="profile-form__input-description">
                                        {item}
                                    </span>
                                );
                            })}
                    </div>
                    <div className="profile-form__column">
                        <label className="profile-form__label">
                            Фамилия
                            <span>*</span>
                        </label>
                        <input
                            id="profileFormSurname"
                            className="profile-form__input"
                            {...register('surname', {
                                required: {
                                    value: true,
                                    message: 'Это поле обязательное',
                                },
                            })}
                            placeholder="Введите фамилию"
                        />
                        {errors.surname && (
                            <span className="profile-form__input-description">
                                {errors.surname.message}
                            </span>
                        )}
                        {serverErrors &&
                            serverErrors.surname &&
                            serverErrors.surname.length > 0 &&
                            serverErrors.surname.map((item: string, index: number) => {
                                return (
                                    <span key={index} className="profile-form__input-description">
                                        {item}
                                    </span>
                                );
                            })}
                    </div>
                </div>
                <div className="profile-form__row">
                    <div className="profile-form__column">
                        <label className="profile-form__label">
                            Название компании
                            <span>*</span>
                        </label>
                        <input
                            id="profileFormCompany"
                            className="profile-form__input"
                            {...register('organization', {
                                required: {
                                    value: true,
                                    message: 'Это поле обязательное',
                                },
                            })}
                            placeholder="Введите компанию"
                        />
                        {errors.organization && (
                            <span className="profile-form__input-description">
                                {errors.organization.message}
                            </span>
                        )}
                        {serverErrors &&
                            serverErrors.organization &&
                            serverErrors.organization.length > 0 &&
                            serverErrors.organization.map((item: string, index: number) => {
                                return (
                                    <span key={index} className="profile-form__input-description">
                                        {item}
                                    </span>
                                );
                            })}
                    </div>
                    <div className="profile-form__column">
                        <label className="profile-form__label">
                            Сфера деятельности
                        </label>
                        <select
                            className="profile-form__select"
                            id="profileFormActivity"
                            {...register('field_of_activity', {
                                required: false,
                            })}
                        >
                            {activities &&
                                activities.length > 0 &&
                                activities.map(
                                    (item: string, index: number) => (
                                        <option
                                            key={index}
                                            value={item}
                                            className="profile-form__option"
                                        >
                                            {item}
                                        </option>
                                    )
                                )}
                        </select>
                        {errors.field_of_activity && (
                            <span className="profile-form__input-description">
                                Это обязательное поле.
                            </span>
                        )}
                        {serverErrors &&
                            serverErrors.field_of_activity &&
                            serverErrors.field_of_activity.length > 0 &&
                            serverErrors.field_of_activity.map(
                                (item: string, index: number) => {
                                    return (
                                        <span key={index} className="profile-form__input-description">
                                            {item}
                                        </span>
                                    );
                                }
                            )}
                    </div>
                </div>
                <div className="profile-form__row">
                    {messages &&
                        messages.id &&
                        status === 'SUCCESS' &&
                        'Регистрация прошла успешно. На ваш email отправлено письмо с инструкцией по активации аккаунта.'}
                </div>
                <div className="profile-form__row">
                    <div className="profile-form__column">
                        <button
                            className={`btn btn--purple profile-form__btn ${
                                (status === 'LOADING' && '_disabled') || ''
                            }`}
                            type="submit"
                        >
                            Зарегистрироваться
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
}
